import { ref } from "vue"

// Mobile bottom sheet with every channel hidden on this device, grouped by category
// (HiddenChannelsDrawer.vue, mounted once in app.vue). Opened by a long-press on an empty spot of the
// channel list and from «Скрытые каналы» in the group menu.
const isOpen = ref(false)
const groupId = ref<string | null>(null)

export function useHiddenChannelsDrawer() {
  function open(id: string) {
    groupId.value = id
    isOpen.value = true
  }

  return { isOpen, groupId, open }
}
